<template lang="pug">
#modal-confirmar-aprovacao
    el-dialog(
        width='500px',
        :title="$t('mensagens.operacao.confirmacaoAprovacao')",
        :visible.sync='mostrar',
        :close-on-click-modal='false'
    )
        p.texto_aprovacao
            | {{ $t('mensagens.operacao.confirmacaoAprovacaoAviso') }}

        .botoes
            BaseButton(@click='fechar') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(type='primary', @click='confirmar') {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalConfirmarAprovacao',
    components: {
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        confirmar() {
            this.$emit('confirmar');
            this.$emit('fechar');
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    gap: 10px;
}
.texto_aprovacao {
    white-space: pre-line;
}
</style>
